import React from "react";
import "./ContactPage.css";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as ContactSVG } from "../../images/contact.svg";
import Title from "../../components/Title/Title";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useForm } from "@formspree/react";

const ContactPage = () => {
  const [state, handleSubmit] = useForm("xpzndqqw");

  const navigate = useNavigate();

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      number: "",
      location: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(15, "Must be 15 characters or less")
        .required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
      number: Yup.string().matches(phoneRegExp, "Phone number is not valid"),
      location: Yup.string()
        .max(12, "Must be 12 characters long")
        .required("Required"),
      message: Yup.string()
        .max(40, "Must be 40 characters or less")
        .required("Required"),
    }),
  });

  if (state.succeeded) {
    navigate("/success");
  }

  return (
    <>
      <div className="contact-container">
        <div className="back-btn">
          <Link to="/">
            <button className="backtohome">&#60; Back to Home</button>
          </Link>
        </div>
        <Title title="Contact Form" />
        <div className="mb-1"></div>
        <Title title="Let's discuss more about techs and projects" />
        <div className="mb-2"></div>
        <div className="contact-box">
          <div className="flex-2">
            <ContactSVG className="contact-svg" />
          </div>

          <div className="flex-2-form">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div>
                <label className="contact-label">Name</label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  className="contact-input"
                  placeholder="John Doe"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.name && formik.errors.name ? (
                  <p className="alert-text">{formik.errors.name}</p>
                ) : null}
              </div>

              <div>
                <label className="contact-label">Email</label>
                <input
                  id="email"
                  type="text"
                  name="email"
                  placeholder="johndoe@email.com"
                  className="contact-input"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <p className="alert-text">{formik.errors.email}</p>
                ) : null}
              </div>

              <div>
                <label className="contact-label">Location</label>
                <input
                  id="location"
                  type="text"
                  className="contact-input"
                  placeholder="Country"
                  name="location"
                  onChange={formik.handleChange}
                  value={formik.values.location}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.location && formik.errors.location ? (
                  <p className="alert-text">{formik.errors.location}</p>
                ) : null}
              </div>

              <div>
                <label className="contact-label">Number</label>
                <input
                  id="number"
                  type="number"
                  name="number"
                  className="contact-input"
                  placeholder="123-45-678"
                  pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                  onChange={formik.handleChange}
                  value={formik.values.number}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.number && formik.errors.number ? (
                  <p className="alert-text">{formik.errors.number}</p>
                ) : null}
              </div>

              <div>
                <label className="contact-label-message">Message</label>
                <textarea
                  type="text"
                  id="message"
                  name="message"
                  className="contact-input-message"
                  placeholder="That's a great job man, keep grooving up 😊!!!"
                  onChange={formik.handleChange}
                  value={formik.values.message}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.message && formik.errors.message ? (
                  <p className="alert-text">{formik.errors.message}</p>
                ) : null}
              </div>
              <div className="contact-button">
                <button className="contact-btn">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
